/* globals lp */
var InvariantsHelper = require('./invariants-helper');
var jQuery = require('jquery');
var _ = require('lodash');

(function() {
  var assert   = lp.invariants.assert
    , register = lp.invariants.register
    , helper   = InvariantsHelper;

  register('FormConfirmationTabPresent', function() {
    const page = window.editor && window.editor.page;
    if (helper.hasElementInPOM("form") && page && page.getConfigValue("showFormConfirmation")) {
      return assert(
        jQuery('.tab-bar-tab-form_confirmation a.tab-button, .tab-bar-tab-form').length === 1,
        "form Confirmation Dialog tab not present even though there is a form on the page"
      );
    } else {
      return true;
    }
  });

  register('FormWidgetDisabled', function() {
    if (helper.hasElementInPOM("form")) {
      return assert(
          jQuery(helper.panelSelectorMapping.widget).find(helper.elmToSelector('form')).hasClass("dsbl"),
          "Form widget is not disabled even though there is a form on the page"
          );
    } else {
      return true;
    }
  });

  register('FormHasAttachedSubmitButton', {

    'detachedSubmit': function(editor) {
      if (helper.hasElementInPOM("form")) {
        return assert(
            _.isObject(editor.page.getForm().submitButton),
            'submit button detached from form'
            );
      } else {
        return true;
      }
    },

    'missingButton': function(editor) {
      if (helper.hasElementInPOM("form")) {
        var buttonId = editor.page.getForm().model.get('content.buttonId')
          , result   = editor.page.getElementById(buttonId);
        return assert(result, 'Submit button missing from POM');
      } else {
        return true;
      }
    }
  });

})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/invariants/form-invariants.js
// module id = 1077
// module chunks = 0